import React from "react"
import { Box, Text, Flex, Button } from "@chakra-ui/react"
import { ReviewType } from "@root/types/reviews"
import { ReviewStarRating } from "@app/components/Product/ProductReviews/ReviewStarRating"

type Props = {
  reviews: ReviewType[]
  reviewsRef: React.RefObject<HTMLDivElement>
}

const ProductTabReviews: React.FC<Props> = ({ reviews, reviewsRef }) => {
  const handleScrollToReviews = () => {
    if (reviewsRef.current) reviewsRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  return (
    <Box padding={{ base: 4, lg: 8 }}>
      <Flex gap={{ base: "16px", lg: "16px" }} flexDir={{ base: "column", lg: "row" }}>
        {reviews.map(review => (
          <Flex flexDir="column" key={review.id} flex={1} alignItems="flex-start" gap={2}>
            <ReviewStarRating numOfStars={review.score} />
            <Text fontSize="16px" lineHeight={1.5} fontWeight="bold">
              {review.contentTitle}
            </Text>
            <Text fontSize="16px" lineHeight={1.5}>
              {review.contentMessage}
            </Text>
          </Flex>
        ))}
      </Flex>
      <Button py={4} onClick={handleScrollToReviews} textDecoration="underline" textUnderlineOffset={3}>
        Read all reviews
      </Button>
    </Box>
  )
}

export default React.memo(ProductTabReviews)
